module.exports = __webpack_public_path__ + "static/media/phone_bg_large.b2980dd1.png";